import { render, staticRenderFns } from "./TrackingScreen.vue?vue&type=template&id=0ea70ba8&scoped=true"
import script from "./TrackingScreen.vue?vue&type=script&lang=js"
export * from "./TrackingScreen.vue?vue&type=script&lang=js"
import style0 from "./TrackingScreen.vue?vue&type=style&index=0&id=0ea70ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea70ba8",
  null
  
)

export default component.exports